
  const data = {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    url: __webpack_public_path__ +  "static/images/" + "sprite-e387ee.svg#close-usage",
  };
  module.exports = data